
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const equipmentShortageChallenge: Challenge = {
  id: 'equipment-shortage',
  title: 'Equipment Shortage',
  description: 'A global shortage of mining ASICs has affected the market. How will you respond?',
  options: [
    {
      text: 'Pay premium prices for immediate delivery',
      outcome: 'You secured the equipment but at a 30% markup, affecting short-term profitability.',
      kpiEffects: {
        profitMargin: -3,
        uptime: 2
      },
      experienceGain: 15
    },
    {
      text: 'Wait for market conditions to improve',
      outcome: 'You saved money but delayed expansion, affecting your mining capacity.',
      kpiEffects: {
        profitMargin: 1,
        efficiency: -2
      },
      experienceGain: 10
    },
    {
      text: 'Seek alternative suppliers in emerging markets',
      outcome: 'You found equipment at reasonable prices but with slightly lower quality.',
      kpiEffects: {
        uptime: -1,
        energyCost: 0.01
      },
      experienceGain: 20,
      skillUnlock: skills.find(s => s.id === 'supply-chain')!
    }
  ],
  difficulty: 3
};
